

const InvestaServices = () => {
    return (
         <section id="services" className="pdtopBottmSection">
        <div className="container">
        <div className="section-label">What We Do</div>
        <h2 className="section-title reveal">Our <em>Services</em></h2>

        <div className="services-grid">
            <div className="service-card reveal">
            <div className="service-num">01</div>
            <div className="service-title">Property <em>Sourcing</em></div>
            <div className="service-text">We identify off-plan, ready, and near-completion stock across Istanbul and Kocaeli — matched to your brief, budget, and investment objective.</div>
            <a href="#contact" className="service-link">Enquire →</a>
            </div>
            <div className="service-card reveal">
            <div className="service-num">02</div>
            <div className="service-title">Citizenship <em>Advisory</em></div>
            <div className="service-text">Navigate Turkey’s citizenship-by-investment route with practical guidance on qualifying assets, timelines, and core transaction steps.</div>
            <a href="#contact" className="service-link">Enquire →</a>
            </div>
            <div className="service-card reveal">
            <div className="service-num">03</div>
            <div className="service-title">Legal <em>Support</em></div>
            <div className="service-text">Investor-focused document support for reservations, title deed transfer, and bilingual communication throughout the process.</div>
            <a href="#contact" className="service-link">Enquire →</a>
            </div>
            <div className="service-card reveal">
            <div className="service-num">04</div>
            <div className="service-title">Investment <em>Analysis</em></div>
            <div className="service-text">Data-backed market positioning, location comparisons, and return modelling for buyers looking at both lifestyle and capital growth.</div>
            <a href="#contact" className="service-link">Enquire →</a>
            </div>
            <div className="service-card reveal">
            <div className="service-num">05</div>
            <div className="service-title">Developer <em>Access</em></div>
            <div className="service-text">Direct sourcing opportunities through established developer relationships, including early-stage stock and selected launch pricing.</div>
            <a href="#contact" className="service-link">Enquire →</a>
            </div>
            <div className="service-card reveal">
            <div className="service-num">06</div>
            <div className="service-title">Rental <em>Management</em></div>
            <div className="service-text">Support with tenant placement, rental coordination, and owner-side protection for clients seeking ongoing income after purchase.</div>
            <a href="#contact" className="service-link">Enquire →</a>
            </div>
        </div>
        </div>
  </section>
    )
}

export default InvestaServices